import React from "react";
import l from "components/util/l";

const RevisionToolbar = ({
  activeSectionIdx,
  sections,
  allowComments,
  isSaving,
  onClickPrevSection,
  onClickSelectSection,
  onClickSaveDraft,
  onClickSaveRevision,
}) => (
  <div className="flex-shrink-0 mt-2">
    <div className="d-flex align-items-center px-0 py-2">
      <div className="d-none d-sm-flex align-items-center flex-fill mr-4 overflow-hidden">
        <div className="d-flex align-items-center flex-shrink-0">
          <button
            type="button"
            className="btn btn-sm btn-outline-light mr-2 d-flex align-items-center justify-content-center"
            style={{ opacity: 0.85, width: "30px", height: "30px", fontSize: "0.78rem", border: "2px solid #ffffff20" }}
            title={l("Índice%PA839")}
            onClick={() => onClickSelectSection(2)}
          >
            <i className="fas fa-list-ul"></i>
          </button>
          <small
            className="text-white-50"
            style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}
          >
            {activeSectionIdx + 1} / {sections.length}
          </small>
        </div>

        <div
          className="flex-fill ml-3 rounded"
          style={{ height: "4px", background: "rgba(255,255,255,0.1)", borderRadius: "4px" }}
        >
          <div
            className="bg-accent"
            style={{
              height: "100%",
              width: `${sections.length > 1 ? Math.round((activeSectionIdx / (sections.length - 1)) * 100) : 100}%`,
              borderRadius: "inherit",
              transition: "width 0.3s ease",
              boxShadow: "0 0 8px rgba(55,125,255,0.5)",
            }}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-shrink-0">
        <button
          type="button"
          className="btn btn-sm btn-outline-light mr-1"
          style={{ opacity: activeSectionIdx === 0 ? 0.35 : 0.85, fontSize: "0.8rem", border: "2px solid #ffffff20" }}
          disabled={activeSectionIdx === 0}
          onClick={onClickPrevSection}
        >
          <i className="fas fa-arrow-left mr-1"></i>
        </button>

        <button
          type="submit"
          className="btn btn-sm btn-outline-light"
          style={{ opacity: activeSectionIdx === sections.length - 1 ? 0.35 : 0.85, fontSize: "0.8rem", border: "2px solid #ffffff20" }}
          disabled={activeSectionIdx === sections.length - 1}
        >
          <i className="fas fa-arrow-right ml-1"></i>
        </button>

        {allowComments && (
          <>
            <div
              className="mx-3"
              style={{
                width: "1px",
                height: "20px",
                background: "rgba(255,255,255,0.2)",
              }}
            />

            <button
              type="button"
              className="btn btn-sm btn-outline-light mr-2"
              style={{ opacity: 0.85, fontSize: "0.8rem" }}
              onClick={onClickSaveDraft}
              disabled={isSaving}
            >
              <i className="fas fa-save mr-1"></i>
              {l("Guardar cambios%PA615")}
            </button>

            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={onClickSaveRevision}
              disabled={isSaving}
            >
              {isSaving
                ? <><i className="fas fa-spinner fa-pulse mr-1"></i>{l("Guardando...%PA611")}</>
                : <><i className="fas fa-paper-plane mr-1"></i>{l("Enviar comentarios%PA610")}</>
              }
            </button>
          </>
        )}
      </div>
    </div>
  </div>
);

export default RevisionToolbar;
